import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TOGGLES_FEATURE_KEY } from './toggles.reducer';

import { FeatureFlagToggleList, FeatureFlagToggles } from '../../interface/feature-flags.interface';

export const selectTogglesState = createFeatureSelector<FeatureFlagToggleList>(TOGGLES_FEATURE_KEY);

export const getToggles = createSelector(selectTogglesState, (state: FeatureFlagToggleList) => state);

export const getToggle = (key: FeatureFlagToggles) =>
  createSelector(selectTogglesState, (state) => (key in state ? state[key] : false));
